import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateSpaceUnassignedSponsoredPeopleComment(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $id: ID!
    $text: String
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                updateSpacePayrollUnassignedSponsoredPeopleComment(
                  id: $id
                  text: $text
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.UpdateSpaceUnassignedSponsoredPeopleCommentMutation,
  undefined,
  graphql.schema.UpdateSpaceUnassignedSponsoredPeopleCommentMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
